import React from 'react'
import './logo.scss'

const Logo = () => {


    return (
        <div className="logo-container">
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="804.000000pt" height="550.000000pt" viewBox="0 0 804.000000 550.000000"
                preserveAspectRatio="xMidYMid meet">

                <g transform="translate(0.000000,550.000000) scale(0.100000,-0.100000)"
                    fill="#000000" stroke="none">
                    <path d="M3767 4262 c-41 -45 -5 -108 55 -99 28 4 41 -2 86 -40 29 -25 55 -43
57 -41 3 2 -18 26 -45 53 -42 42 -50 55 -50 87 0 27 -5 40 -19 48 -30 15 -66
12 -84 -8z"/>
                    <path d="M4317 4242 c-10 -10 -17 -32 -17 -48 0 -24 -11 -36 -56 -69 -30 -22
-51 -41 -45 -43 6 -2 33 12 59 32 42 30 54 34 86 29 27 -4 41 -1 56 12 24 22
26 68 4 89 -21 22 -67 20 -87 -2z"/>
                    <path d="M4030 4099 c-116 -48 -127 -210 -17 -263 64 -30 125 -17 176 38 51
55 34 167 -31 210 -31 20 -97 28 -128 15z"/>
                    <path d="M3607 3900 c-68 -54 -20 -154 68 -141 29 4 54 30 63 64 7 28 15 32
92 54 47 14 87 27 89 29 14 14 -15 10 -91 -12 l-87 -24 -25 25 c-31 31 -74 33
-109 5z"/>
                    <path d="M4224 3882 c3 -5 30 -17 61 -28 46 -15 59 -25 70 -51 19 -45 56 -61
89 -39 77 50 12 146 -69 102 -30 -16 -34 -16 -84 3 -55 22 -75 26 -67 13z"/>
                    <path d="M4015 3719 c-17 -74 -21 -81 -50 -94 -64 -26 -82 -84 -41 -131 30
-36 86 -39 118 -6 32 32 30 88 -4 117 l-27 23 15 63 c8 35 16 74 19 87 3 12 2
22 -3 22 -5 0 -17 -36 -27 -81z"/>
                </g>
            </svg>

        </div>
    )
}

export default Logo

